// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1U9Pm","wrapperOpened":"styles_wrapperOpened__wJxqe","inner":"styles_inner__dwsFe","iconWrap":"styles_iconWrap__2LAN_","content":"styles_content__4s_iP","action":"styles_action__eJ3hk"};
module.exports.__checksum = "4a4589ff04ed"
